@switch (mode) {
  @case ('compact') {
    <div>
      <span class="text-xs">
        {{ indicatorStore.getParentName(indicator) }}: </span
      ><br />
      <span class="text-xs">
        {{ indicator.name }}
      </span>
    </div>
  }
  @case ('quiet') {
    <div>
      {{ indicator.name }} <br />
      <span class="text-color-secondary text-xs">
        {{ indicatorStore.getParentName(indicator) }}
      </span>
    </div>
  }
  @case ('tooltip') {
    <span [pTooltip]="indicatorStore.getFullName(indicator)">{{
      indicator.name
    }}</span>
  }
  @default {
    {{ indicatorStore.getFullName(indicator) }}
  }
}
